/*
 * サブシステム名：経営管理
 * 機能名：日報NO毎売上明細
 */

import DdSubHeader from '@/components/DdSubHeader'
import DdDefaultButton from '@/components/DdDefaultButton'
import DdNarrowDownTextBox from '@/components/DdNarrowDownTextBox'
import DdRowCountBox from '@/components/DdRowCountBox'
import DdFooterButton from '@/components/DdFooterButton'
import DdDataTable from '@/components/DdDataTable'
import DdCodeTextBox from '../../components/DdCodeTextBox.vue'
import DdTextBox from '../../components/DdTextBox.vue'
import DdDateBox from '@/components/DdDateBox'
import DdRadioButton from '@/components/DdRadioButton'
import flowMixin from '@/mixins/flowMixins'
import filter from '@/rahmen/utils/filters'
import { mapGetters } from 'vuex'
import header from '@/ddv2.library/header'

export default {
  name: 'NippouNoUriageList',
  mixins: [flowMixin],
  data: () => ({
    expansionPanel: [0, 1],
    conditions: {},
    headersEigyoshoList: header.mstEigyoshoHeaders,
    headersJininList: header.mstJininHeaders,
    headersSharyoList: header.mstSharyoHeaders,
    headersTorihikisakiList: header.mstTorihikisakiHeaders,
    modeKengen: 0,
    page: 1,
    isCsvDownloader: false,
    isPdfDownloader: false
  }),
  components: {
    DdSubHeader,
    DdDefaultButton,
    DdNarrowDownTextBox,
    DdRowCountBox,
    DdFooterButton,
    DdDataTable,
    DdCodeTextBox,
    DdDateBox,
    DdRadioButton,
    DdTextBox
  },
  computed: {
    filteredRows () {
      console.log('filter', this.rows)
      return this.rows.map((elem) => {
        elem.nippoYmdDisp = elem.nippoYmd ? filter.dateFormatter(elem.nippoYmd) : ''
        elem.jissekiShukkoYmdDisp = elem.jissekiShukkoYmd ? filter.dateFormatter(elem.jissekiShukkoYmd) : ''
        elem.jissekiKikoYmdDisp = elem.jissekiKikoYmd ? filter.dateFormatter(elem.jissekiKikoYmd) : ''

        elem.sagyoJikanDisp = elem.sagyoJikan ? filter.minToTimeFormatter(elem.sagyoJikan) : ''
        elem.kyusokuJikanDisp = elem.kyusokuJikan ? filter.minToTimeFormatter(elem.kyusokuJikan) : ''
        elem.kadouJikanDisp = elem.kadouJikan ? filter.minToTimeFormatter(elem.kadouJikan) : ''

        elem.hatsuchiOdoMaterDisp = elem.hatsuchiOdoMater === 0 || elem.hatsuchiOdoMater ? filter.numericFormatter(elem.hatsuchiOdoMater) : null
        elem.chakuchiOdoMaterDisp = elem.chakuchiOdoMater === 0 || elem.chakuchiOdoMater ? filter.numericFormatter(elem.chakuchiOdoMater) : null
        elem.sokoKyoriDisp = elem.sokoKyori === 0 || elem.sokoKyori ? filter.numericFormatter(elem.sokoKyori) : null
        elem.kushaKyoriDisp = elem.kushaKyori === 0 || elem.kushaKyori ? filter.numericFormatter(elem.kushaKyori) : null
        elem.jisshaKyoriDisp = elem.jisshaKyori === 0 || elem.jisshaKyori ? filter.numericFormatter(elem.jisshaKyori) : null
        elem.kyuyuSuryoDisp = elem.kyuyuSuryo === 0 || elem.kyuyuSuryo ? filter.numericFormatter(elem.kyuyuSuryo) : null

        elem.seikyuKingakuDisp = elem.seikyuKingaku === 0 || elem.seikyuKingaku ? filter.numericFormatter(elem.seikyuKingaku) : null
        elem.uriageKingakuKeiDisp = elem.uriageKingakuKei === 0 || elem.uriageKingakuKei ? filter.numericFormatter(elem.uriageKingakuKei) : null
        elem.shiharaiKingakuKeiDisp = elem.shiharaiKingakuKei === 0 || elem.shiharaiKingakuKei ? filter.numericFormatter(elem.shiharaiKingakuKei) : null
        elem.hiwayPriceKeiDisp = elem.hiwayPriceKei === 0 || elem.hiwayPriceKei ? filter.numericFormatter(elem.hiwayPriceKei) : null
        elem.humanPriceKeiDisp = elem.humanPriceKei === 0 || elem.humanPriceKei ? filter.numericFormatter(elem.humanPriceKei) : null
        elem.uriageKingakuKeiDisp = elem.uriageKingakuKei === 0 || elem.uriageKingakuKei ? filter.numericFormatter(elem.uriageKingakuKei) : null
        elem.shiharaiKingakuKeiDisp = elem.shiharaiKingakuKei === 0 || elem.shiharaiKingakuKei ? filter.numericFormatter(elem.shiharaiKingakuKei) : null
        elem.jissekiEnginePriceKeiDisp = elem.jissekiEnginePriceKei === 0 || elem.jissekiEnginePriceKei ? filter.numericFormatter(elem.jissekiEnginePriceKei) : null
        elem.hiwayPriceKeiDisp = elem.hiwayPriceKei === 0 || elem.hiwayPriceKei ? filter.numericFormatter(elem.hiwayPriceKei) : null
        elem.humanPriceKeiDisp = elem.humanPriceKei === 0 || elem.humanPriceKei ? filter.numericFormatter(elem.humanPriceKei) : null
        elem.jissekiHendoPriceKeiDisp = elem.jissekiHendoPriceKei === 0 || elem.jissekiHendoPriceKei ? filter.numericFormatter(elem.jissekiHendoPriceKei) : null
        elem.jissekiGenkaiRiekiDisp = elem.jissekiGenkaiRieki === 0 || elem.jissekiGenkaiRieki ? filter.numericFormatter(elem.jissekiGenkaiRieki) : null
        elem.jissekiRiekiRateDisp = elem.jissekiRiekiRate === 0 || elem.jissekiRiekiRate ? filter.numericFormatter(elem.jissekiRiekiRate) : null
        elem.anbunJissekiEnginePriceDisp = elem.anbunJissekiEnginePrice === 0 || elem.anbunJissekiEnginePrice ? filter.numericFormatter(elem.anbunJissekiEnginePrice) : null
        elem.anbunHiwayPriceDisp = elem.anbunHiwayPrice === 0 || elem.anbunHiwayPrice ? filter.numericFormatter(elem.anbunHiwayPrice) : null
        elem.anbunHumanPriceDisp = elem.anbunHumanPrice === 0 || elem.anbunHumanPrice ? filter.numericFormatter(elem.anbunHumanPrice) : null
        elem.jissekiHendoPriceDisp = elem.jissekiHendoPrice === 0 || elem.jissekiHendoPrice ? filter.numericFormatter(elem.jissekiHendoPrice) : null
        if (elem.jissekiShukkoHms) { elem.jissekiShukkoHms = (elem.jissekiShukkoHms).slice(0, 5) }
        if (elem.jissekiKikoHms) { elem.jissekiKikoHms = (elem.jissekiKikoHms).slice(0, 5) }
        elem.key = `${elem.sagyoJissekiId}/${elem.sagyoMeisaiId ?? 0}/${elem.jomuinId}`

        return elem
      })
    },
    iskamotsu () {
      if (this.conditions.kamotsuYn !== '1') {
        return false
      }
      return true
    },
    isRenraku () {
      if (this.conditions.renrakuYn !== '1') {
        return false
      }
      return true
    },
    isCsvButtonDisabled () {
      return this.rows.length === 0 || this.isCsvDownloader
    },
    isPdfButtonDisabled () {
      return this.rows.length === 0 || this.isPdfDownloader
    },
    ...mapGetters({
      eigyoshoList: 'DDMasters/mstEigyosho',
      jininList: 'DDMasters/mstJinin',
      sharyoList: 'DDMasters/mstSharyo',
      torihikisakiList: 'DDMasters/mstTorihikisaki',
      loginEigyoshoCd: 'users/eigyoshoCd'
    }),
    filteredEigyoshoList () {
      const target = filter.dateFormatter(new Date())
      return this.eigyoshoList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.eigyoshoCd > elem2.eigyoshoCd) { return 1 }
        if (elem1.eigyoshoCd === elem2.eigyoshoCd) { return 0 }
        return -1
      })
    },
    filteredJininList () {
      const target = filter.dateFormatter(new Date())
      return this.jininList.map((elem) => {
        elem.jininNm = elem.jininNmSei + (elem.jininNmMei ? ' ' + elem.jininNmMei : '')
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.jininCd > elem2.jininCd) { return 1 }
        if (elem1.jininCd === elem2.jininCd) { return 0 }
        return -1
      })
    },
    filteredSharyoList () {
      var numberPlateWk = []
      const target = filter.dateFormatter(new Date())
      return this.sharyoList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        numberPlateWk = []
        numberPlateWk.push(elem.torokuChimei)
        numberPlateWk.push(elem.torokuBunruiNo)
        numberPlateWk.push(elem.torokuHiragana)
        numberPlateWk.push(elem.torokuIchirenShiteiNo)
        elem.numberPlate = numberPlateWk.join(' ')
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.sharyoCd > elem2.sharyoCd) { return 1 }
        if (elem1.sharyoCd === elem2.sharyoCd) { return 0 }
        return -1
      })
    },
    filteredTorihikisakiList () {
      const target = filter.dateFormatter(new Date())
      return this.torihikisakiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.torihikisakiCd > elem2.torihikisakiCd) { return 1 }
        if (elem1.torihikisakiCd === elem2.torihikisakiCd) { return 0 }
        return -1
      })
    }
  },
  created () {
  },
  mounted () {
    this.initialize()
  },
  beforeRouteUpdate (to, from, next) {
    this.$refs.initialize()
    next()
  },
  methods: {
    getCloneTargetMethod: function () {
      return {
        rows: this.rows,
        conditions: this.conditions,
        searchText: this.searchText
      }
    },
    initialize: function () {
      const self = this
      const opt = {
        loadMasters: ['msttorihikisaki', 'msteigyosho', 'mstjinin', 'mstsharyo'],
        defineHeaderPromise: () => {
          return new Promise(resolve => {
            console.log('NippouNoUriageList.defineHeaderPromise')
            self.headers = [
              { text: '日報No', value: 'nippoNo' },
              { text: '日報日', value: 'nippoYmdDisp', align: 'center' },
              { text: '日報種別', value: 'haishaKbnNm' },
              { text: '営業所コード', value: 'sagyoEigyoshoCd' },
              { text: '営業所名称', value: 'sagyoEigyoshoNm' },
              { text: '乗務員区分', value: 'tenjoFlgNm' },
              { text: '乗務員コード', value: 'jomuinCd' },
              { text: '乗務員名', value: 'jomuinNm' },
              { text: '傭車先コード', value: 'yoshasakiCd' },
              { text: '傭車先名', value: 'yoshasakiNm' },
              { text: '車両番号', value: 'sharyoNo' },
              { text: '車両ナンバープレート', value: 'sharyoNoPlate' },
              { text: '車種', value: 'shashuSbtNm' },
              { text: '連絡事項', value: 'sagyoRenrakuBiko' },
              { text: '出庫日', value: 'jissekiShukkoYmdDisp', align: 'center' },
              { text: '出庫時刻', value: 'jissekiShukkoHms', align: 'center' },
              { text: '帰庫日', value: 'jissekiKikoYmdDisp', align: 'center' },
              { text: '帰庫時刻', value: 'jissekiKikoHms', align: 'center' },
              { text: '拘束時間', value: 'sagyoJikanDisp', align: 'center' },
              { text: '休憩時間', value: 'kyusokuJikanDisp', align: 'center' },
              { text: '稼働時間', value: 'kadouJikanDisp', align: 'center' },
              { text: '出庫時オドメータ', value: 'hatsuchiOdoMaterDisp', align: 'end' },
              { text: '帰庫時オドメータ', value: 'chakuchiOdoMaterDisp', align: 'end' },
              { text: '走行距離', value: 'sokoKyoriDisp', align: 'end' },
              { text: '空車距離', value: 'kushaKyoriDisp', align: 'end' },
              { text: '実車距離', value: 'jisshaKyoriDisp', align: 'end' },
              { text: '給油量', value: 'kyuyuSuryoDisp', align: 'end' },
              { text: '貨物No', value: 'juchuNo' },
              { text: '荷主コード', value: 'ninushiCd' },
              { text: '荷主名称', value: 'ninushiNm' },
              { text: '発地コード', value: 'hatsuchiCd' },
              { text: '発地名称', value: 'hatsuchiNm' },
              { text: '卸先コード', value: 'oroshisakiCd' },
              { text: '卸先名称', value: 'oroshisakiNm' },
              { text: '着地コード', value: 'chakuchiCd' },
              { text: '着地名称', value: 'chakuchiNm' },
              { text: '往復区分', value: 'ohfukuSbtNm' },
              { text: '商品種別', value: 'hinmokuSbt' },
              { text: '商品コード', value: 'hinmeiCd' },
              { text: '商品名', value: 'hinmeiNm' },
              { text: '売上金額', value: 'uriageKingakuKeiDisp', align: 'end' },
              { text: '支払金額', value: 'shiharaiKingakuKeiDisp', align: 'end' },
              { text: '燃料代', value: 'jissekiEnginePriceKeiDisp', align: 'end' },
              { text: '通行料', value: 'hiwayPriceKeiDisp', align: 'end' },
              { text: '人件費', value: 'humanPriceKeiDisp', align: 'end' },
              { text: '変動費', value: 'jissekiHendoPriceKeiDisp', align: 'end' },
              { text: '限界利益', value: 'jissekiGenkaiRiekiDisp', align: 'end' },
              { text: '利益率', value: 'jissekiRiekiRateDisp', align: 'end' }
            ]
            resolve()
          })
        },
        initializeInputPromise: function () {
          return new Promise((resolve) => {
            console.log('initializeInputPromise')
            var loginEigyoshoId = 0
            if (self.filteredEigyoshoList) {
              const loginEigyosho = self.filteredEigyoshoList.filter((elem) => {
                return elem.eigyoshoCd === self.loginEigyoshoCd
              })
              if (loginEigyosho.length !== 0) {
                loginEigyoshoId = loginEigyosho[0].id
              }
            }
            const startDate = new Date(new Date().getFullYear(), new Date().getMonth(), 1)
            const endDate = new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)
            const startYmdString = `${startDate.getFullYear()}/${('0' + (startDate.getMonth() + 1)).slice(-2)}/${('0' + (startDate.getDate())).slice(-2)}`
            const endYmdString = `${endDate.getFullYear()}/${('0' + (endDate.getMonth() + 1)).slice(-2)}/${('0' + (endDate.getDate())).slice(-2)}`
            self.conditions = {
              searchEigyoshoId: loginEigyoshoId,
              jomuinId: null,
              sharyoId: null,
              nippouStartYmd: startYmdString,
              nippouEndYmd: endYmdString,
              kamotsuYn: '9',
              juchuMeisaiNo: '',
              ninushiId: null,
              renrakuYn: '9',
              sagyoRenrakuBiko: ''
            }
            resolve()
          })
        },
        savedInputRestorePromise: (c) => {
          console.log('NippouNoUriageList.savedInputRestorePromise', c)
          // ユーザ保存項目の復元
          self.conditions = { ...self.conditions, ...c }
          return new Promise(resolve => {
            self.loadFromCache()
              .then((c) => {
                console.log('NippouNoUriageList.savedInputRestorePromise after loadFromCache', c)
                resolve()
              })
          })
        },
        researchPromise: (c) => {
          console.log('NippouNoUriageList.researchPromise', c)
          return new Promise(resolve => {
            self.conditions = c.cache.value.conditions || {}
            self.onSearchButtonClick()
            resolve()
            // self.search().then(() => {
            //   resolve()
            // })
          })
        },
        restoreViewPromise: (c) => {
          console.log('NippouNoUriageList.restoreViewPromise', c)
          return new Promise(resolve => {
            self.conditions = c.cache.value.conditions || {}
            self.searchText = c.cache.value.searchText || ''
            self.rows = c.cache.value.rows || []
            resolve()
          })
        },
        settingButtonStatePromise: (kengen) => {
          console.log('settingButtonStatePromise', kengen)
          return new Promise(resolve => {
            console.log('settingButtonStatePromise', kengen)
            if (kengen.kengenKbn === '10') {
              // 読取モード
              self.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              self.modeKengen = 1
            } else {
              // フルアクセス
              self.modeKengen = 2
            }
            resolve()
          })
        }
      }
      this.initializeForViewer(opt)
    },
    onSearchButtonClick: function (e) {
      const self = this
      const opt = {
        searchRequestPromise: function () {
          return new Promise(resolve => {
            self.HttpClient.post('/api/v1/vwCThbzmd0060/search', self.conditions)
              .then((data) => {
                resolve(data)
              })
          })
        },
        searchResultMethod: function (data) {
          self.rows = data.payload

          const cache = {
            rows: self.rows,
            conditions: self.conditions,
            searchText: self.searchText
          }
          self.saveToChache(cache)
            .then(() => {
            })
        },
        getSavedInputMethod: function () {
          return {}
        }
      }
      this.search(opt)
    },
    onClearButtonClick: function (e) {
      console.log('clear pushed')
      this.Effects.loadStart()
      this.clear()
    },
    clear: function () {
      console.log('clear pushed')
      const self = this
      const opt = {
        clearInputsPromise: () => {
          return new Promise(resolve => {
            var loginEigyoshoId = 0
            if (self.filteredEigyoshoList) {
              const loginEigyosho = self.filteredEigyoshoList.filter((elem) => {
                return elem.eigyoshoCd === self.loginEigyoshoCd
              })
              if (loginEigyosho.length !== 0) {
                loginEigyoshoId = loginEigyosho[0].id
              }
            }
            const startDate = new Date(new Date().getFullYear(), new Date().getMonth(), 1)
            const endDate = new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)
            const startYmdString = `${startDate.getFullYear()}/${('0' + (startDate.getMonth() + 1)).slice(-2)}/${('0' + (startDate.getDate())).slice(-2)}`
            const endYmdString = `${endDate.getFullYear()}/${('0' + (endDate.getMonth() + 1)).slice(-2)}/${('0' + (endDate.getDate())).slice(-2)}`
            self.conditions = {
              searchEigyoshoId: loginEigyoshoId,
              jomuinId: null,
              sharyoId: null,
              nippouStartYmd: startYmdString,
              nippouEndYmd: endYmdString,
              kamotsuYn: '9',
              juchuMeisaiNo: '',
              ninushiId: null,
              renrakuYn: '9',
              sagyoRenrakuBiko: ''
            }
            resolve()
          })
        }
      }
      this.clearInputs(opt)
    },
    onCsvButtonClick: function (e) {
      this.isCsvDownloader = true
      this.HttpClient.post('/api/v1/VwCThbzmd0060/download', this.conditions).then((data) => {
        const bom = new Uint8Array([0xEF, 0xBB, 0xBF])
        const blob = new Blob([bom, data], { type: 'text/csv' })
        const elem = document.getElementById('download')
        this.isCsvDownloader = false
        elem.href = window.URL.createObjectURL(blob)
        elem.click()
      })
    },
    onPdfButtonClick: function (e) {
      this.isPdfDownloader = true
      this.HttpClient
        .requestFileByPost('/api/v1/VwCThbzmd0060/pdfdownload', this.conditions)
        .then((data) => {
          const blob = new Blob([data], { type: 'application/pdf' })
          const elem = document.getElementById('pdfdownload')
          this.isPdfDownloader = false
          elem.href = window.URL.createObjectURL(blob)
          elem.click()
        })
    },
    searchValidate: function () {
      return true
    }
  }
}
